import type { FC } from 'react'
import { Button, type ButtonProps } from "@chakra-ui/react"
import { Link as RouterLink} from "react-router-dom"
import { MdOutlineRemoveRedEye } from 'react-icons/md';

export const GoToProductButton: FC<{
  productPagePath: string;
  text?: string,
  size?: ButtonProps['size']
}> = ({productPagePath, text = 'Zobacz', size='md' }) => {

  return (
    <Button
      size={size}
      px={{base: 4, md: 6}}
      width={{base: '100%', md: 'inherit'}}
      py={{base: 4, md: 'inherit'}}
      as={RouterLink} 
      colorScheme={'black'}
      borderColor={'blackAlpha.700'}
      variant={'outline'}
      leftIcon={<MdOutlineRemoveRedEye />}
      to={productPagePath}
      boxShadow={'inner'}
      borderWidth={2}
      _hover={{
        bgColor: 'creamy'
      }}
    >
      {text}
    </Button>
  )
}